import React from "react";
import { usePermissions } from "../../../../auth/PermissionProvider";
import { Permissions } from "../../../../auth/permissions";

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Vazio é válido (campo opcional); preenchido precisa ser GUID. */
export const tenantEntraValido = (valor: string) => {
  const v = valor.trim();
  return v === "" || GUID.test(v);
};

/** O que vai no corpo: vazio vira `null`, GUID vai em minúsculas. */
export const tenantEntraParaEnvio = (valor: string): string | null => {
  const v = valor.trim().toLowerCase();
  return v === "" ? null : v;
};

type Props = {
  id: string;
  value: string;
  onChange: (valor: string) => void;
  disabled?: boolean;
  labelCls: string;
  inputCls: string;
};

/** Tenant Microsoft (Entra ID) da organização: liga o login Microsoft das pessoas dela. */
const TenantEntraField: React.FC<Props> = ({ id, value, onChange, disabled, labelCls, inputCls }) => {
  // O backend só aceita mudança do tenant de quem administra identidade (D196): para os demais, só leitura.
  const { can } = usePermissions();
  const podeEditar = can(Permissions.IdentidadeAdmin);
  const invalido = !tenantEntraValido(value);
  return (
    <div className="flex flex-col gap-1.5 sm:col-span-2">
      <label htmlFor={id} className={labelCls}>
        Tenant Microsoft (Entra ID)
      </label>
      <input
        id={id}
        value={value}
        disabled={disabled || !podeEditar}
        onChange={(e) => onChange(e.target.value)}
        aria-describedby={`${id}-ajuda`}
        aria-invalid={invalido}
        className={`${inputCls} tabular-nums`}
        placeholder="00000000-0000-0000-0000-000000000000"
      />
      <p id={`${id}-ajuda`} className="text-xs text-gray-700 dark:text-gray-300">
        ID do diretório do Microsoft Entra da empresa. Preencha para que as pessoas dela entrem com a conta Microsoft.
        {!podeEditar && " Só quem administra identidade pode alterar."}
      </p>
      {invalido && (
        <p role="alert" className="text-xs font-medium text-red-600 dark:text-red-300">
          Informe um GUID válido, como 00000000-0000-0000-0000-000000000000.
        </p>
      )}
    </div>
  );
};

export default TenantEntraField;
